import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Broker } from '../../app/models/broker';
import { environment } from '../../environments/environment';
import { FTLCustomer } from 'src/app/models/ftl-customer';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private _primaryBroker: Broker;

  private _customers: FTLCustomer[];

  constructor(private http: HttpClient) { }

  get primaryBroker(): Broker {
    return this._primaryBroker;
  }

  getBrokerForCustomer(): Observable<Broker> {
    return this.http.get<Broker>(`${environment.traxFtlApiServerUrl}/MyBroker`);
  }

  setBroker(broker: Broker) {
    this._primaryBroker = broker;
  }

  get brokerCustomers(): FTLCustomer[] {
    return this._customers;
  }
  
  getCustomersForBroker() {
    return this.http.get<FTLCustomer[]>(`${environment.traxFtlApiServerUrl}/MyCustomers`);
  }
  
  setCustomers(customers: FTLCustomer[]) {
    this._customers = customers;
  }

}
